// src/pages/Enseignants/PassagesGrades/components/GradeFiltersBar.jsx

import React, { useEffect, useMemo, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { getGroupLabel } from "../utils/gradePassageUtils";

const GradeFiltersBar = ({
  loading,
  dojos,
  selectedDojo,
  onDojoChange,
  groups,
  filterGroup,
  onGroupChange,
  seasons,
  selectedSeason,
  onSeasonChange,
  search,
  onSearchChange,
  resultFilter,
  onResultFilterChange,
  sortBy,
  onSortByChange,
  hideStopped,
  onToggleHideStopped,
}) => {
  const [localSearch, setLocalSearch] = useState(search || "");

  useEffect(() => {
    setLocalSearch(search || "");
  }, [search]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onSearchChange(localSearch);
    }, 250);

    return () => clearTimeout(timeout);
  }, [localSearch, onSearchChange]);

  const hasSingleDojo = useMemo(() => (dojos || []).length === 1, [dojos]);

  const labelClass =
    "mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400";

  const fieldClass =
    "h-11 w-full rounded-2xl border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 outline-none transition focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:border-blue-400 dark:disabled:bg-slate-900";

  return (
    <div className="space-y-4">
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-5">
        <div>
          <label className={labelClass}>Saison</label>
          <select
            className={fieldClass}
            value={selectedSeason}
            onChange={(event) => onSeasonChange(event.target.value)}
            disabled={loading}
          >
            {(seasons || []).map((season) => (
              <option key={season} value={season}>
                {season}
              </option>
            ))}
          </select>
        </div>

        {!hasSingleDojo && (
          <div>
            <label className={labelClass}>Dojo</label>
            <select
              className={fieldClass}
              value={selectedDojo}
              onChange={(event) => onDojoChange(event.target.value)}
              disabled={loading}
            >
              <option value="">Tous les dojos</option>
              {(dojos || []).map((dojo) => (
                <option key={dojo.id} value={String(dojo.id)}>
                  {dojo.dojo_nom || dojo.nom || `Dojo ${dojo.id}`}
                </option>
              ))}
            </select>
          </div>
        )}

        <div>
          <label className={labelClass}>Groupe</label>
          <select
            className={fieldClass}
            value={filterGroup}
            onChange={(event) => onGroupChange(event.target.value)}
            disabled={loading}
          >
            <option value="">Sélectionner un groupe</option>
            {(groups || []).map((group) => {
              const label = getGroupLabel(group);

              return (
                <option key={group.id || label} value={label}>
                  {label}
                </option>
              );
            })}
          </select>
        </div>

        <div>
          <label className={labelClass}>État passage</label>
          <select
            className={fieldClass}
            value={resultFilter}
            onChange={(event) => onResultFilterChange(event.target.value)}
            disabled={loading}
          >
            <option value="all">Tous</option>
            <option value="not_graded">Non notés</option>
            <option value="graded">Notés</option>
            <option value="obtained">Obtenus</option>
            <option value="failed">Non obtenus</option>
          </select>
        </div>

        <div>
          <label className={labelClass}>Tri</label>
          <select
            className={fieldClass}
            value={sortBy}
            onChange={(event) => onSortByChange(event.target.value)}
            disabled={loading}
          >
            <option value="not_graded_first">Non notés en premier</option>
            <option value="graded_first">Notés en premier</option>
            <option value="recent">Date récente</option>
            <option value="alpha">Alphabétique</option>
          </select>
        </div>
      </div>

      <div className="flex flex-col gap-3 lg:flex-row lg:items-end">
        <div className="flex-1">
          <label className={labelClass}>Recherche</label>
          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              className={`${fieldClass} pl-11`}
              placeholder="Nom ou prénom de l’adhérent"
              value={localSearch}
              onChange={(event) => setLocalSearch(event.target.value)}
              disabled={loading}
            />
          </div>
        </div>

        <button
          type="button"
          onClick={() => onToggleHideStopped(!hideStopped)}
          className={`inline-flex h-11 items-center justify-center rounded-2xl border px-4 text-sm font-bold transition ${
            hideStopped
              ? "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300"
              : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300"
          }`}
        >
          {hideStopped ? "Arrêts masqués" : "Afficher les arrêts"}
        </button>
      </div>
    </div>
  );
};

export default GradeFiltersBar;